<template>
  <v-sheet :color="themeColor" >
    <div class="logo-wrapper pl-3">
      <img
        :width="logoWidth"
        :height="logoHeight"
        :src="logoSrc"
      ></img>
    </div>
  </v-sheet>
</template>

<script>
import { COMPANYINFO__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState("company", ["generalInfo"]),

    themeColor() {
      return this.$vuetify.theme.dark ? "#162334" : "#E8F1F8";
    },

    logoWidth() {
      return this.generalInfo?.logo_width || "100px";
    },

    logoHeight() {
      return this.generalInfo?.logo_height || "100px";
    },

    logoSrc() {
      return this.$vuetify.theme.dark ? this.generalInfo?.logo_url : this.generalInfo?.logo_url_dark ;
    },

    companyName() {
      return this.generalInfo?.company_name || "Forex Crm";
    },
  },

  methods: {
    ...mapActions("company", [COMPANYINFO__ACTIONS.COMPANYINFO]),

    async fetchCompanyInfo() {
      try {
        await this[COMPANYINFO__ACTIONS.COMPANYINFO]();
      } catch (error) {
        console.error("Failed to fetch company info:", error);
      }
    },
  },

  async mounted() {
    await this.fetchCompanyInfo();
  },
};
</script>
